import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./Mission.module.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import RookTech from "../../images/rook-no-bg.png";

const Mission = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.pageWrapper}>
      <Navbar />
      <main className={styles.missionMain}>
        <img
          className={styles.towerBackground}
          src={RookTech}
          alt="Rook Tech Background"
        />

        <section className={styles.contentContainer}>
          <div className={styles.glassCard}>
            <h2 className={styles.cardTitle}>{t("mission.visionTitle")}</h2>
            <p>{t("mission.visionP1")}</p>
            <p>{t("mission.visionP2")}</p>
          </div>

          <div className={styles.glassCard}>
            <h2 className={styles.cardTitle}>{t("mission.missionTitle")}</h2>
            <p>{t("mission.missionP1")}</p>
            <p>{t("mission.missionP2")}</p>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Mission;
